module.exports = __webpack_public_path__ + "static/media/NTL.dfed8eb4.jfif";